import * as $ from "jquery";
declare var Vimeo: any;
declare var gtag: any;
import { Monitor } from "./monitor";

// This will come from the database later
interface VideoItem {
    id: number;
    vimeoid: string;
    title: string;
    videoviewitemid: number;
    //questionTabName: string;
}

const vimeooptions = {
    title: false,
    portrait: false,
    muted: false,
    loop: false,
    autoplay: true,
    responsive: true,
};

export class VideoReel2 {
    $videowrap: JQuery;
    player: any;
    videos: Array<VideoItem>;
    currentvideo: VideoItem;
    currentvimeoid: string | null;
    clockStart: number;
    monitor: Monitor;

    constructor(videos: Array<VideoItem>) {
        const self = this;
        this.videos = videos;
        this.$videowrap = $(".herovideo");
        this.currentvimeoid = null;
        this.monitor = new Monitor();

        $(".vid").on("click", function () {
            const number = parseInt($(this).data("number"));
            self.launchVideo(number, true);
        });

        $(".modal .mask, .modal .fa-times").on("click", function () {
            self.stopVideo();
        });
    }

    async launchVideo(id: number, play: boolean) {
        $(".vid.playing").removeClass("playing");
        const $selectedVideo = $("#vidthumb-" + id);
        $selectedVideo.addClass("playing");
        const subtitle: string = $selectedVideo.data("subtitle");
        const title: string = $selectedVideo.data("title");
        $("#playing-vid-subtitle").text(subtitle + ":");
        $("#playing-vid-title").text(title);
        this.stopVideo();
        this.currentvideo = this.videos[id];
        if (play) {
            this.$videowrap.addClass("playing");
            try {
                await this.monitor.create(this.currentvideo.videoviewitemid);
                this.playVideo(this.currentvideo.vimeoid);
                gtag("event", "view_promotion", {
                    "event_label": this.currentvideo.title,
                    "event_category": "video_play",
                });
            } catch {
                //console.log("Unable to play video");
            }
        }
    }

    playVideo(vimeoid: string) {
        if (!this.player) {
            this.createPlayer(vimeoid);
        } else if (this.currentvimeoid == vimeoid) {
            // player created... same video. Just continue
            this.player.play();
        } else {
            // if player already exists then just create a new one
            const self = this;
            this.player
                .loadVideo(vimeoid)
                .then(function () {
                    self.player.play();
                });
        }
        this.currentvimeoid = vimeoid;
    }

    createPlayer(vimeoid: string) {
        const self = this;
        const optionsvideo = {
            ...vimeooptions,
            id: vimeoid,
        };
        this.player = new Vimeo.Player("videoreelvimeo", optionsvideo);
        this.player.on("ended", () => {
            self.monitor.stop();
            $(".vid.playing").removeClass("playing");
        });
    }

    // stop video from playing
    stopVideo() {
        this.monitor.stop();
        if (this.player) {
            this.player.pause();
        }
    }
}
